export function formatPhoneInput(input: string) {
  if (!input) return input;

  let digits = unformatPhone(input);
  const hasCountryCode = digits.charAt(0) === '1';

  const formatDigits = (start: number, middle: number, end: number) => {
    return `(${digits.substring(start, middle)}) ${digits.substring(
      middle,
      end
    )}-${digits.substring(end)}`;
  };

  if (hasCountryCode) {
    if (digits.length > 11) {
      digits = digits.substring(0, 11); // Truncate digits to 11 if there's a country code
    }

    if (input.length <= 4) return input;
    if (input.length <= 9) {
      return `1 (${digits.substring(1, 4)}) ${digits.substring(4)}`;
    }
    return `1 ${formatDigits(1, 4, 7)}`;
  }

  if (digits.length > 10) {
    digits = digits.substring(0, 10); // Truncate digits to 10 if there's no country code
  }

  if (input.length <= 4) return `(${digits}`;
  if (input.length <= 8) return formatDigits(0, 3, 6);
  return formatDigits(0, 3, 6);
}

export function formatPhone(input: string) {
  if (!input) return input;
  const NO_COUNTRY_FORMAT_PATTERN = '($1) $2-$3';
  const COUNTRY_FORMAT_PATTERN = '$1 ($2) $3-$4';
  if (input.charAt(0) === '1') {
    return input.replace(
      /(\d{1})(\d{3})(\d{3})(\d{4})/,
      COUNTRY_FORMAT_PATTERN
    );
  }
  return input.replace(/(\d{3})(\d{3})(\d{4})/, NO_COUNTRY_FORMAT_PATTERN);
}

export function unformatPhone(input: string) {
  return input.replace(/\D/g, '');
}

export function formatCountryPhone(input: string): string {
  if (!input) return '';

  const phone = unformatPhone(input);

  if (phone.charAt(0) === '1') {
    return `+${formatPhone(phone)}`;
  }
  return `+1 ${formatPhone(phone)}`;
}

// It will consider the following formats as valid phone numbers:
// "+1 323-674-6358",
// "+1 (562) 267-3970",
// "(631) 223-8009",
// "786) 424-2507",
// "(816 839-9926",
// "914-486-2916",
// "931.820.2711",
// "5203379215",
// "123 456-7890"
export function isValueAPhoneNumber(value: string): boolean {
  return /^(\+?1\s?)?(\(?\d{3}\)?)[-\s.]?\d{3}[-\s.]?\d{4}$/.test(value);
}
